import React, { Component } from 'react'
import {Select, MenuItem, Modal, CircularProgress} from '@material-ui/core';
import {send} from '../helper/requests'
import { loadReCaptcha } from 'react-recaptcha-v3'
import { ReCaptcha } from 'react-recaptcha-v3'
import Header from './Header'

var base64;
var cleanBase64;
class Form extends Component {
    constructor() {
        super()
        this.state = {
            file: [],
            chars_left:'0',
            fileName:'',
            userName:'',
            userSurname:'',
            userPhone:'',
            detailMessage:'',
            userMail:'',
            selectedQuestion:'0',
            busy:false,
            nameError:false,
            surnameError:false,
            emailError:false,
            modalShow:false,
            success:false,
            failed:false,
            isButtonDisabled:false
        }
        this.handleImageChange = this.handleImageChange.bind(this);
        this.emailRegex = new RegExp('[A-Z0-9a-z._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,64}');
        this.verifyCallback = this.verifyCallback.bind(this)
      }

    handleChange (event) {
        this.setState({ [event.target.name] : event.target.value })
        //this.nameValidation()
    }
        handleTextCount(event){
            var input = event.target.value;
            this.setState({
                chars_left:input.length,
                detailMessage:input
            })
        }

    handleImageChange(e) {
        e.preventDefault();
        let file = e.target.files[0];
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = () => {
          this.setState({
            file: file,
            fileName:file.name,
        });
        base64=reader.result
        cleanBase64 = base64.substring(22)
          //this.handleSubmit()
          console.log(base64)
        };
      }
    back  = (e) => {
        e.preventDefault();
        this.props.prevStep();
    }


   clearForm(){
       this.setState({
        file: [],
        chars_left:'0',
        fileName:'',
        userName:'',
        userSurname:'',
        userPhone:'',
        detailMessage:'',
        userMail:'',
        selectedQuestion:'0',
        busy:false,
        nameError:false,
        surnameError:false,
        emailError:false,
        modalShow:false,
        success:false,
        failed:false,
        isButtonDisabled:false
       })
   }
    async formSubmit(){
        if(!this.state.captchaToken){
            return
        }
        this.setState({
            nameError:false, 
            surnameError:false,
            questionError:false,
            phoneError:false,
            emailError:false
        })
        if(this.state.busy){
            return
        }
        if(this.state.isButtonDisabled){
            return
        }
        
        this.setState({
            busy:true,
            modalShow:true,
            isButtonDisabled:true
        })
        if(this.state.selectedQuestion === '0'){
            this.setState({questionError:true, busy:false, modalShow:false,isButtonDisabled:false})
            return
        }
        if(!this.state.userName || this.state.userName.length < 2){
            this.setState({nameError:true, busy:false, modalShow:false,isButtonDisabled:false})
            return

        }
        if(!this.state.userSurname || this.state.userSurname.length < 2){
            this.setState({surnameError:true, busy:false, modalShow:false,isButtonDisabled:false})
            return
        }
        if(!this.state.userMail || !this.emailRegex.test(this.state.userMail)){
            console.log('email validation failed')
            this.setState({emailError:true, busy:false, modalShow:false,isButtonDisabled:false})
            return
        }
        if(!this.state.userPhone || this.state.userPhone.length < 10){
            this.setState({phoneError:true, busy:false, modalShow:false,isButtonDisabled:false})
            return
        }

        const data={
            subject:this.state.selectedQuestion,
            name:this.state.userName,
            surname:this.state.userSurname,
            phoneNumber:'+90'+ this.state.userPhone,
            message:this.state.detailMessage,
            file:cleanBase64,
            email:this.state.userMail
        }
        try {
            const upload = await send({
            url:'/api/v1/website/support/mail',
            method:'POST', 
            data,
            })
            this.setState({
                success:true,
                busy:false,
                file: [],
                chars_left:'0',
                fileName:'',
                userName:'',
                userSurname:'',
                userPhone:'',
                detailMessage:'',
                userMail:'',
            })
        }catch(err){
            this.setState({
                failed:true
            })
        }
    }
    getAnswers = async(e) => {
        if(e.target.value !== "") {
            this.setState({
                selectedQuestion:e.target.value
            })
        }
    }
    componentDidMount(){
        try{
            loadReCaptcha('6LclWPQUAAAAANBPtqIPPXEHs5oFLW2VD8_-wRpn');
        }catch(err){
            console.log(err)
        }
    }
    verifyCallback = (recaptchaToken) => {
        if (recaptchaToken) {
            this.setState({
                captchaToken:recaptchaToken
            })
        }
      }
    render() {
        const Input = React.createRef();
        return (
            <div className="mainContainer">
            <Header/>
            <div className="validationContainer whiteBG">
                <ReCaptcha
                    sitekey="6LclWPQUAAAAANBPtqIPPXEHs5oFLW2VD8_-wRpn"
                    action='form'
                    verifyCallback={this.verifyCallback}
                />
                <div className="formArea">
                <div className="formRow">
                    <div className="formColumn columnOne">
                    <label htmlFor="questions">Konu</label>
                        <Select
                            id="questions"
                            name="questions"
                            className={`questionSelect ${this.state.questionError ? 'mailError':''}`}
                            value={this.state.selectedQuestion}
                            onChange={this.getAnswers.bind(this)}
                            >
                                <MenuItem value="0">
                                    Soru Seçiniz
                                </MenuItem>
                                <MenuItem value="Üyelik">
                                    Üyelik
                                </MenuItem>
                                <MenuItem value="Gelir-Gider">
                                    Gelir&Gider
                                </MenuItem>
                                <MenuItem value="Harcama Takibi">
                                    Harcama Takibi
                                </MenuItem>
                                <MenuItem value="Grup-Sohbet">
                                    Grup&Sohbet
                                </MenuItem>
                                <MenuItem value="Diğer">
                                    Diğer
                                </MenuItem>
                            </Select>
                        </div>
                    </div>
                    <div className="formRow">
                        <div className="formColumn">
                            <label htmlFor="userName">Ad</label>
                            <input type="text" name="userName" value={this.state.userName} className={`whiteBG ${this.state.nameError ? 'mailError':''}`} placeholder="Adınızı giriniz" onChange={this.handleChange.bind(this)} minLength="2" maxLength="20" />
                        </div>
                        <div className="formColumn surnameMobile">
                            <label htmlFor="userSurname">Soyad</label>
                            <input type="text" name="userSurname" value={this.state.userSurname} className={`whiteBG ${this.state.surnameError ? 'mailError':''}`} placeholder="Soyadınızı giriniz" onChange={this.handleChange.bind(this)} minLength="2" maxLength="20" />
                        </div>
                    </div>
                    <div className="formRow">
                        <div className="formColumn columnOne">
                            <label htmlFor="userPhone">Telefon Numarası</label>
                            <div className="phoneHolder">
                                <span className={`phoneLabel ${this.state.phoneError ? 'mailError':''}`}>+90</span>
                                <input type="number" name="userPhone" value={this.state.userPhone} className={`whiteBG ${this.state.phoneError ? 'mailError':''}`} placeholder="5001234567" maxLength="10" onChange={this.handleChange.bind(this)}/>
                            </div>
                            <span className="phoneNotification">Kassa’ya üye olduğunuz telefon numarasını giriniz.</span>
                        </div>
                    </div>
                    <div className="formRow">
                        <div className="formColumn columnOne">
                            <label htmlFor="userMail">Email Adresi</label>
                            <input type="text" name="userMail" value={this.state.userMail} className={`whiteBG ${this.state.emailError ? 'mailError':''}`} placeholder="Mail adresini giriniz" onChange={this.handleChange.bind(this)} maxLength="60"/>
                        </div>
                    </div>
                    <div className="formRow">
                        <div className="formColumn columnOne">
                            <label htmlFor="detailMessage">Detay</label>
                            <textarea name="detailMessage" className="detailQuestion" placeholder="Buraya yazınız..." maxLength="1200" onChange={this.handleTextCount.bind(this)} value={this.state.detailMessage}></textarea>
                            <span className="characterLimit">{this.state.chars_left}/1200</span>
                            <label htmlFor="files" onClick={ () => { Input.current.click(); } } className="uploadFile">Dosya Yükle</label><label className="fileList">{this.state.fileName}</label>
                            <input
                                hidden
                                type='file'
                                name='files'
                                accept='image/png, image/jpeg'
                                ref={ Input }
                                onChange={ this.handleImageChange }
                            />
                            <img src={this.state.fileSelf}/>
                        </div>
                    </div>
                    
                    <div className="formRow noBorder">
                        <input type="submit" className="formSubmit" onClick={this.formSubmit.bind(this)} value="DEVAM"/>
                    </div>
                    
                </div>
                <Modal
                    open={this.state.modalShow}
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    className="modalMain"
                    onClose={this.clearForm.bind(this)}
                    >
                        <div className='modalcontentContainer'>
                            {this.state.busy ? <CircularProgress /> : ''}
                            {this.state.success ?
                            <div className="modalContent">
                                <h2>Gönderildi</h2>
                                <p>Talebiniz Kullanıcı Deneyimi Ekiplerimize ulaşmıştır. <br/>
                                    Sizinle en yakın sürede iletişime geçeceğiz.</p>
                                <input type="submit" className="formSubmit" onClick={this.clearForm.bind(this)} value="TAMAM"/>
                            </div> : <div></div>}
                            {this.state.failed ?
                            <div className="modalContent">
                                <h2>Hata</h2>
                                <p>Bir hata oluştu.<br/>
                                    Lütfen daha sonra tekrar deneyin.</p>
                                <input type="submit" className="formSubmit" onClick={this.clearForm.bind(this)} value="TAMAM"/>
                            </div> : <div></div>}
                        </div>
                    </Modal>
            </div>
            </div>
        )
    }
}
export default Form